import { CheckboxGroupProps } from 'antd/lib/checkbox';
import { Checkbox, Col, Row } from 'antd';
import { ContainerCheckBoxGroup } from './styles';

interface IOptions {
  label: string;
  value: string | number;
}
interface ICheckBoxGroupProps extends CheckboxGroupProps {
  children?: React.ReactNode | string;
  options: IOptions[];
}

export const ACheckBoxGroup: React.FC<ICheckBoxGroupProps> = ({
  options,
  value,
  onChange,
  ...res
}) => {
  const plainOptions = options.map((opt) => opt.value);
  const checkedList = value || [];

  const indeterminate =
    !!checkedList.length && checkedList.length < plainOptions.length;
  const checkAll = checkedList.length === plainOptions.length;

  const onCheckAllChange = (e: any) => {
    const newCheckedList = e.target.checked ? plainOptions : [];

    if (onChange) {
      onChange(newCheckedList);
    }
  };

  return (
    <ContainerCheckBoxGroup>
      <Row style={{ marginLeft: 6 }}>
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
        >
          Selecionar tudo
        </Checkbox>
      </Row>
      <Checkbox.Group {...res} value={value} onChange={onChange}>
        <Row>
          {options.map((opt, index) => (
            <Col key={`checkbox-${index}`} style={{ margin: 6 }}>
              <Checkbox value={opt.value}>{opt.label}</Checkbox>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    </ContainerCheckBoxGroup>
  );
};
